import React, { Component } from 'react';
import { client } from '../utils/contentful.js'
import { generateKey } from '../utils/utils.js'
import Contact from './Components/ContactInfo'
import AboutInfo from './Components/AboutInfo'
class About extends Component {
  state = {
    about: null
  }
  componentDidMount() {
    this.getContent()
  }

  getContent = () => {
    client.getEntries({
      content_type: 'info'
    })
      .then((res) => {
        if (!res.items || !res.items[0]) return;
        this.setState({ about: res.items });
      })
      .catch((err) => {
        console.error('About fetch failed', err);
        this.setState({ aboutError: true });
      });
  }

  render() {
    let aboutText;
    let collabText;
    if (this.state.about !== null) {
      const fields = this.state.about[0].fields;
      if (fields.about && fields.about.content) {
        aboutText = fields.about.content.map((content, index) => {
          return <AboutInfo content={content} key={generateKey(index)} index={index} />
        })
      }
      if (fields.selectedCollaborators && fields.selectedCollaborators.content) {
        collabText = fields.selectedCollaborators.content.map((content, index) => {
          return <AboutInfo content={content} key={generateKey(index)} index={index} />
        })
      }
    }
    return (
      <div className={`about ${this.props.display}`}>
        <main>
          <button onClick={this.props.closeInfo}>Close</button>
          <div> {this.state.about !== null && aboutText} </div>
          <h3>Contact</h3>
          {this.state.about !== null && <Contact about={this.state.about} />}
          {collabText && <h3>Selected Collaborators To Date</h3>}
          {collabText}
          <small
          >
            <h3><a
              rel="noopener noreferrer"
              style={{ color: 'gray' }}
              href="http://www.madeline-omoore.com" target="_blank">website by mo</a></h3>
          </small>
        </main>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/About/About.js